import React, { Component } from 'react';
/* eslint-disable */
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
// import Topbar from '../Apanel/topbar/Topbar';
// import Sidebar from '../Apanel/sidebar/Sidebar';
import TopbarWithNavigationrec from '../Apanel/topbar_with_navigation/TopbarWithNavigationrec';
import Dashboard from './components/Dashboard';
import Profile from '../Apanel/index';
import ProfileEdit from '../Apanel/UserProfileEdit';
import AddTest from './components/AddTest';
import FaqTechView from './components/FaqTechView';
import FaqTechQues from './components/FaqTechQues';
import SaveTest from './components/SaveTest';
import CustomSavedTest from './components/CustomSavedTest';
import CustomSentTests from './components/CustomSentTests';
import CusComTest from './components/CusComTest';
import CustomTestReport from './components/CustomTestReport';
import SentTests from './components/SentTests';
import ComTest from './components/ComTest';
import TestReport from '../Apanel/TestReport';
import Emailids from './components/Emailids';
import Mytickets from './components/Mytickets';
import Viewticket from './components/Viewticket';
import Activet from './components/Activet';
import Closedt from './components/Closedt';
import AddQuest from './components/AddQuest';
import ViewQuest from './components/ViewQuest';
import Allmycustoms from './components/Allmycustoms';
import MyQuestions from './components/MyQuestions';
const initialstate = {
	sidebarShow: false,
	sidebarCollapse: false,
};

class RecruiterPanel extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		// this.insertTawkto();
	}
	insertTawkto() {
		var Tawk_API = Tawk_API || {},
			Tawk_LoadStart = new Date();
		(function () {
			var s1 = document.createElement('script'),
				s0 = document.getElementsByTagName('script')[0];
			s1.async = true;
			s1.src = 'https://embed.tawk.to/5da35321fbec0f2fe3b98448/default';
			s1.charset = 'UTF-8';
			s1.setAttribute('crossorigin', '*');
			s0.parentNode.insertBefore(s1, s0);
		})();
	}

	changeSidebarVisibility = () => {
		this.setState((prevState) => ({
			sidebarCollapse: !prevState.sidebarCollapse,
		}));
	};

	changeMobileSidebarVisibility = () => {
		this.setState((prevState) => ({ sidebarShow: !prevState.sidebarShow }));
	};

	render() {
		const { sidebarShow, sidebarCollapse } = this.state;
		const layoutClass = classNames({
			layout: true,
			'layout--collapse': sidebarCollapse,
		});

		return (
			<div>
				{/* <div className={layoutClass}> */}
				<div className="layout layout--top-navigation">
					{/* <Topbar
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
						changeSidebarVisibility={this.changeSidebarVisibility}
					/>
					<Sidebar
						sidebarShow={sidebarShow}
						sidebarCollapse={sidebarCollapse}
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
					/> */}
					<TopbarWithNavigationrec
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
					/>
				</div>
				<div className="container__wrap">
					<Route path="/emailids" component={Emailids} />
					<Route path="/testreport" component={TestReport} />
					<Route path="/addtest" component={AddTest} />
					<Route path="/faqtechview" component={FaqTechView} />
					<Route path="/faqtechsques" component={FaqTechQues} />
					<Route path="/savetest" component={SaveTest} />
					<Route path="/customsavedtest" component={CustomSavedTest} />
					<Route path="/customsenttest" component={CustomSentTests} />
					<Route path="/cuscomtest" component={CusComTest} />
					<Route path="/custestreport" component={CustomTestReport} />
					<Route path="/senttests" component={SentTests} />
					<Route path="/comtest" component={ComTest} />
					<Route path="/mytickets" component={Mytickets} />
					<Route path="/viewticket" component={Viewticket} />
					<Route path="/closedt" component={Closedt} />
					<Route path="/activet" component={Activet} />
					<Route path="/addcustomtest" component={AddQuest} />
					<Route path="/viewcustomtest" component={ViewQuest} />
					<Route path="/mycustoms" component={Allmycustoms} />
					<Route path="/myqueslist" component={MyQuestions} />
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/profile" component={Profile} />
					<Route path="/profileedit" component={ProfileEdit} />
				</div>
			</div>
		);
	}
}

export default withRouter(RecruiterPanel);
